import isEmpty from './isEmpty';
import getInactive from './getInactive';

const isActive = data =>
  !isEmpty(data) && !getInactive(data);

export default isActive;